import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useLocation } from 'react-router-dom';
import App from './App';

if (process.env.APP_ENV !== 'local' && !window?.['__SENTRY__']?.version) {
  Sentry.init({
    dsn: 'https://f0f9cb77c50a43dcb3c347aaf8f85e2b@o113506.ingest.us.sentry.io/4505425839587328',
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
      }),
      Sentry.replayIntegration(),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: `freshsurvey-web-admin-app@${
      process.env.COMMIT_ID || 'COMMIT_ID'
    }`,
    environment: process.env.APP_ENV || 'local',
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root-app'),
);
